__turbopack_context__.v({
  "editLink": "CreatorBanner-module-scss-module__9l_wja__editLink",
});
